import { useCallback, useState } from 'react';

export default function useAuthModel() {
  const [user, setUser] = useState<any>(null);

  const signin = useCallback(() => {}, []);

  const signout = useCallback(() => {
    // signout implementation
    // setUser(null)
  }, []);

  return {
    user,
    signin,
    signout,
  };
}
